(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    window.onload = () =>
        new Splide('.splide', {
            type: 'loop',
            arrows: false,
            classes: {
                pagination: 'splide__pagination slider-pagination',
                page: 'splide__pagination__page slider-pagination-page',
            },
        }).mount();
  } catch(e) { console.error(e); }
})();

})();
